import SaveIcon from "@mui/icons-material/Save";
import {
  Alert,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Stack,
  TextField,
} from "@mui/material";
import { useState } from "react";
import { toast } from "react-toastify";

import FinancialCoreApi from "../../../../../infrastructure/api/financialCore";

/**
 * ثبت تکی واریز وام با شماره درخواست + مبلغ + شماره سند.
 * @param {{ open: boolean, source?: string, onClose: () => void, onCommitted?: () => void }} props
 */
const LoanDisbursementSingleDialog = ({
  open,
  source = "SolarentOperator",
  onClose,
  onCommitted,
}) => {
  const [form, setForm] = useState({
    requestNumber: "",
    amount: "",
    trackingNumber: "",
    description: "",
  });
  const [submitting, setSubmitting] = useState(false);

  const reset = () => {
    setForm({
      requestNumber: "",
      amount: "",
      trackingNumber: "",
      description: "",
    });
    setSubmitting(false);
  };

  const handleClose = () => {
    if (submitting) return;
    reset();
    onClose?.();
  };

  const handleSubmit = async () => {
    const requestNumber = form.requestNumber.trim();
    const trackingNumber = form.trackingNumber.trim();
    const amount = Number(String(form.amount).replace(/,/g, "").trim());

    if (!requestNumber) {
      toast.warning("شماره درخواست را وارد کنید.");
      return;
    }
    if (!Number.isFinite(amount) || amount <= 0) {
      toast.warning("مبلغ واریزی معتبر نیست.");
      return;
    }
    if (!trackingNumber) {
      toast.warning("شماره سند را وارد کنید.");
      return;
    }

    setSubmitting(true);
    try {
      const res = await FinancialCoreApi.registerLoanDisbursementByRequestNumber(
        source,
        {
          requestNumber,
          amount,
          trackingNumber,
          description: form.description.trim() || null,
        }
      );
      if (res?.isSuccess === false) {
        toast.error(res?.message || res?.Message || "ثبت واریز ناموفق بود.");
        return;
      }
      toast.success(res?.message || res?.Message || "واریز وام ثبت شد");
      reset();
      onCommitted?.();
      onClose?.();
    } catch (e) {
      const apiMsg =
        e?.response?.data?.message ||
        e?.response?.data?.Message ||
        e?.message;
      toast.error(apiMsg || "ثبت واریز ناموفق بود.");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <Dialog open={open} onClose={handleClose} maxWidth="sm" fullWidth>
      <DialogTitle>ثبت واریز تکی وام</DialogTitle>
      <DialogContent dividers>
        <Alert severity="info" sx={{ mb: 2 }}>
          برای یک پرونده، شماره درخواست، مبلغ واریزی (ریال) و شماره سند بانکی را
          وارد کنید.
        </Alert>
        <Stack spacing={1.5}>
          <TextField
            label="شماره درخواست"
            size="small"
            fullWidth
            placeholder="مثلاً 14009285 یا PRJ-14009285"
            value={form.requestNumber}
            onChange={(e) =>
              setForm((f) => ({ ...f, requestNumber: e.target.value }))
            }
            disabled={submitting}
          />
          <TextField
            label="مبلغ واریزی (ریال)"
            size="small"
            fullWidth
            value={form.amount}
            onChange={(e) => setForm((f) => ({ ...f, amount: e.target.value }))}
            disabled={submitting}
          />
          <TextField
            label="شماره سند"
            size="small"
            fullWidth
            value={form.trackingNumber}
            onChange={(e) =>
              setForm((f) => ({ ...f, trackingNumber: e.target.value }))
            }
            disabled={submitting}
          />
          <TextField
            label="توضیح (اختیاری)"
            size="small"
            fullWidth
            multiline
            minRows={2}
            value={form.description}
            onChange={(e) =>
              setForm((f) => ({ ...f, description: e.target.value }))
            }
            disabled={submitting}
          />
        </Stack>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose} disabled={submitting}>
          انصراف
        </Button>
        <Button
          variant="contained"
          color="success"
          startIcon={<SaveIcon />}
          disabled={submitting}
          onClick={handleSubmit}
        >
          {submitting ? "در حال ثبت…" : "ثبت واریز"}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default LoanDisbursementSingleDialog;
